if (!customElements.get('product-options')) {
  customElements.define(
    'product-options',
    class ProductOptions extends window.BAO.CustomElement() {
      setupListeners () {
        super.setupListeners()

        if (this.els.trigger.elements.length < 2) return

        this.handleTrigger = this.handleTrigger.bind(this)

        this.listeners.add(this, 'click', this.handleTrigger)
      }

      handleTrigger (event) {
        const trigger = event.target.closest(
          `[data-product-options-el="trigger"]`,
        )
        if (!trigger) return

        const optionIndex = trigger.dataset.index
        const optionValue = trigger.dataset.value

        this.els.trigger.elements.forEach(triggerEl => {
          if (triggerEl.dataset.index === optionIndex) {
            const isCurrentTrigger = triggerEl === trigger

            triggerEl.setAttribute('aria-pressed', isCurrentTrigger)

            triggerEl.querySelector(
              '[data-message]',
            ).innerText = isCurrentTrigger
              ? window.variantStrings.sizeSelected
              : triggerEl.querySelector('[data-message]').dataset
                .originalMessage
          }
        })

        window.BAO.utils
          .getElements('.prd-Options_Select')
          .forEach(selectEl => {
            if (selectEl.dataset.index === optionIndex) {
              selectEl.value = optionValue

              selectEl.dispatchEvent(new Event('change', { bubbles: true }))
            }
          })

        window.BAO.utils.getElement(
          '[data-variant-title]',
        ).innerText = optionValue
      }
    },
  )
}
